import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface DataListCardFieldProps {
  label: string;
  children: ReactNode;
  className?: string;
}

/** Label + value block for mobile list row cards (reuse column header strings as labels). */
export function DataListCardField({
  label,
  children,
  className,
}: DataListCardFieldProps): JSX.Element {
  return (
    <div className={cn("min-w-0 space-y-1", className)}>
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
      <div className="text-sm text-foreground">{children}</div>
    </div>
  );
}
